import { useSvgParsedStyle } from '@/_shared/hooks/useSvgParsedStyle';
import { SvgProps } from '@/_shared/types/svg';

export const LightBulb = ({ style }: SvgProps) => {
  const { primaryColorToUse, heightToUse, widthToUse } = useSvgParsedStyle({
    defaultWidth: '25',
    defaultHeight: '25',
    style,
  });

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={widthToUse}
      height={heightToUse}
      fill='none'
      viewBox='0 0 25 25'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M8.04 3.4222C9.35275 2.10945 11.1332 1.37195 12.9897 1.37195C14.8463 1.37195 16.6267 2.10945 17.9395 3.4222C19.2522 4.73496 19.9897 6.51543 19.9897 8.37195C19.9897 9.91042 19.4017 11.4847 18.1796 12.5963C17.4575 13.3213 17.1142 13.8489 16.9703 14.5681C16.862 15.1096 16.3352 15.4608 15.7936 15.3525C15.2521 15.2442 14.9009 14.7174 15.0092 14.1758C15.2642 12.9007 15.9165 12.0309 16.7826 11.1648C16.795 11.1524 16.8078 11.1404 16.8208 11.1287C17.5845 10.4413 17.9897 9.42474 17.9897 8.37195C17.9897 7.04587 17.463 5.7741 16.5253 4.83641C15.5876 3.89873 14.3158 3.37195 12.9897 3.37195C11.6637 3.37195 10.3919 3.89873 9.45421 4.83641C8.51653 5.7741 7.98975 7.04587 7.98975 8.37195C7.98975 9.1762 8.12838 10.0964 9.19685 11.1648C9.95309 11.9211 10.7136 12.8922 10.9703 14.1758C11.0786 14.7174 10.7274 15.2442 10.1859 15.3525C9.6443 15.4608 9.11748 15.1096 9.00917 14.5681C8.86589 13.8517 8.4264 13.2228 7.78264 12.5791C6.25111 11.0475 5.98975 9.5677 5.98975 8.37195C5.98975 6.51543 6.72724 4.73496 8.04 3.4222ZM8.98975 18.3719C8.98975 17.8197 9.43746 17.3719 9.98975 17.3719H15.9897C16.542 17.3719 16.9897 17.8197 16.9897 18.3719C16.9897 18.9242 16.542 19.3719 15.9897 19.3719H9.98975C9.43746 19.3719 8.98975 18.9242 8.98975 18.3719ZM9.98975 22.3719C9.98975 21.8197 10.4375 21.3719 10.9897 21.3719H14.9897C15.542 21.3719 15.9897 21.8197 15.9897 22.3719C15.9897 22.9242 15.542 23.3719 14.9897 23.3719H10.9897C10.4375 23.3719 9.98975 22.9242 9.98975 22.3719Z'
        fill={primaryColorToUse}
      />
    </svg>
  );
};
